import { Effect } from 'effect'
import { getPriceFx, getStatsFx } from '~/api/grpc/effect'

import serverCache from '~/lib/memory-cache'
import { PriceInfo, StatsInfo } from '~/api/grpc/service'
import { createServerFn } from '@tanstack/react-start'

const supportedSlugs = ['monero', 'zcash', 'zano', 'litecoin', 'pirate-chain']

const getStats = async () =>
{
    const cacheKey = 'stats'
    const cached = serverCache.get(cacheKey)
    if (cached) {
        return Promise.resolve(cached as unknown as StatsInfo)
    }

    const stats = await Effect.runPromise(getStatsFx())
    for (const blockchain in stats.coins) {
        if (!supportedSlugs.includes(blockchain)) {
            delete stats.coins[blockchain]
        }
    }
    serverCache.set(cacheKey, stats)
    return stats
}

export const serverGetStats = createServerFn({ method: 'GET' }).handler(() => getStats())

const getPrice = async () =>
{
    const cacheKey = 'prices'
    const cached = serverCache.get(cacheKey)
    if (cached) {
        return Promise.resolve(cached as unknown as PriceInfo)
    }

    const prices = await Effect.runPromise(getPriceFx())
    for (const blockchain in prices) {
        if (!supportedSlugs.includes(blockchain)) {
            delete prices.prices[blockchain]
        }
    }
    serverCache.set(cacheKey, prices)
    return prices
}

export const serverGetPrice = createServerFn({ method: 'GET' }).handler(() => getPrice())